import { render, staticRenderFns } from "./NewPage.vue?vue&type=template&id=e9d258e6&"
import script from "./NewPage.vue?vue&type=script&lang=ts&"
export * from "./NewPage.vue?vue&type=script&lang=ts&"
import style0 from "./NewPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewPage.vue"
export default component.exports